import React from 'react'

import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'

import Typography from 'components/Typography'

import classes from './LastUpdatedDate.module.scss'

dayjs.extend(advancedFormat)

/** @type {import("./types").default} */
const LastUpdatedDate = ({ lastUpdatedDate }) => {
  if (!lastUpdatedDate) return null
  const lastUpdated = lastUpdatedDate && dayjs(lastUpdatedDate).format('MMMM YYYY')

  return (
    <Typography className={classes.root} variant="tight-xs">
      {`Last updated: ` + lastUpdated}
    </Typography>
  )
}

export default LastUpdatedDate
